const countryJobLocation = async (countryCode) => {
    const data = {
        "countries": countryCode,
    }
    try {
        const response = await fetch(`${process.env.GATSBY_JOBS_URL}/getLocationsByCountry`, {
            method: "POST",
            headers: {
                "appid": process.env.GATSBY_APP_ID,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });     
        const result = await response.json();
        let locationData = []
        result.map(obj => {
            locationData.push(...obj.locations)
        })
        return locationData || []
    } catch (error) {
        throw new Error(error)
    }
}

module.exports = { countryJobLocation }
